/* R44 — My Garage pop-out: email step before saving a car.
   Visitors who aren't logged in, haven't signed up and aren't known to Klaviyo enter their email in the pop-out
   before "Add to garage" saves the car: they're subscribed to Klaviyo (same list, key and properties as the homepage
   My Garage signup) and then EasySearch saves the car as normal. Known visitors save straight away.
   Also keeps the pop-out side tab reading GARAGE, and on phones (749px and narrower) turns the pop-out into a
   full-width sheet from the bottom: round garage button bottom right, dimmed page behind, page scroll locked,
   close button inside the sheet, and the sheet lifts above the on-screen keyboard.
   Loaded from snippets/r44-klaviyo-garage.liquid (data-list / data-key / data-source / data-customer on the script tag).
   Test the new-visitor view with ?r44_garage_test=1 (?r44_garage_test=0 to undo). */
(function () {
  'use strict';
  var cfg = (document.currentScript && document.currentScript.dataset) || {};
  var LIST = cfg.list || 'VZnX2h', KEY = cfg.key || 'XBX5MC', SOURCE = cfg.source || 'My Garage';
  var CUSTOMER = cfg.customer === '1';
  var DONE_KEY = 'r44-garage-signed-up';
  var LEGAL = 'By signing up you agree to receive marketing emails from R44 Performance. Unsubscribe at any time. See our <a href="/policies/privacy-policy">privacy policy</a>.';

  function getLS(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function withTimeout(p, ms, v) { return Promise.race([Promise.resolve(p), new Promise(function (r) { setTimeout(function () { r(v); }, ms); })]); }

  var testMode = false;
  try {
    if (/[?&]r44_garage_test=1/.test(location.search)) sessionStorage.setItem('r44-garage-test', '1');
    if (/[?&]r44_garage_test=0/.test(location.search)) sessionStorage.removeItem('r44-garage-test');
    testMode = sessionStorage.getItem('r44-garage-test') === '1';
  } catch (e) {}

  // Known visitor? Logged in, signed up on this browser, or identified by Klaviyo
  var klaviyoKnown = false;
  (function check(n) {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      withTimeout(k.isIdentified(), 4000, false).then(function (v) { klaviyoKnown = v === true; }, function () {});
    } else if (n < 40) { setTimeout(function () { check(n + 1); }, 250); }
  })(0);
  function known() { return !testMode && (CUSTOMER || !!getLS(DONE_KEY) || klaviyoKnown); }

  function wrapperOf(el) { return el && el.closest && el.closest('.easysearch-garage-select-wrapper'); }
  function selectedCar(wrap) {
    var sels = wrap.querySelectorAll('.easysearch-field-select-holder select'), vals = [];
    for (var i = 0; i < sels.length; i++) {
      if (!sels[i].value) return null;
      vals.push(((sels[i].options[sels[i].selectedIndex] || {}).text || sels[i].value).trim());
    }
    return vals.length >= 3 ? { year: vals[0], make: vals[1], model: vals[vals.length - 1] } : null;
  }
  function shortName(c) { return (c.make === 'BMW' ? '' : c.make + ' ') + c.model; }

  var bypass = false;

  function gateFor(wrap) {
    var g = wrap.querySelector('.r44pg');
    if (g) return g;
    g = document.createElement('div');
    g.className = 'r44pg';
    g.hidden = true;
    g.innerHTML =
      '<p class="r44pg__title" data-r44pg-title></p>' +
      '<form class="r44pg__form" novalidate>' +
        '<input type="email" name="email" required autocomplete="email" placeholder="Your email address" aria-label="Your email address">' +
        '<button type="submit" class="r44pg__btn">Save vehicle</button>' +
      '</form>' +
      '<p class="r44pg__msg" data-r44pg-msg aria-live="polite" hidden></p>' +
      '<p class="r44pg__legal">' + LEGAL + '</p>' +
      '<button type="button" class="r44pg__cancel" data-r44pg-cancel>Cancel</button>';
    var widget = wrap.querySelector('.easysearch-widget') || wrap;
    widget.appendChild(g);

    var form = g.querySelector('form'), input = form.querySelector('input'), btn = form.querySelector('button');
    var msg = g.querySelector('[data-r44pg-msg]');
    function show(text, type) { msg.hidden = false; msg.textContent = text; msg.className = 'r44pg__msg' + (type ? ' is-' + type : ''); }

    // Cancel sits under the email step (EasySearch's own Cancel is hidden while it's open)
    g.querySelector('[data-r44pg-cancel]').addEventListener('click', function () {
      var nativeCancel = wrap.querySelector('.easysearch-actions-holder a.easysearch-garage-btn:not(.easysearch-btn-search)');
      closeGate(wrap);
      if (nativeCancel) nativeCancel.click();
    });
    // Phones: keep "Save vehicle" in view above the on-screen keyboard
    input.addEventListener('focus', function () {
      [350, 700].forEach(function (ms) { setTimeout(function () {
        // Scroll only the pop-out's own list (scrollIntoView would also move the page behind it)
        var box = btn.closest('.easysearch-garage-content');
        if (!box) return;
        var over = btn.getBoundingClientRect().bottom - box.getBoundingClientRect().bottom + 12;
        if (over > 0) box.scrollTop += over;
      }, ms); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var car = selectedCar(wrap);
      if (!car) { show('Choose your Year, Make and Model first.', 'error'); return; }
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show('Please enter a valid email address.', 'error'); input.focus(); return; }
      var props = {
        'Signup Source': SOURCE,
        'Signup Page': location.pathname,
        'Primary Vehicle': [car.year, car.make, car.model].join(' '),
        'Primary Vehicle Year': car.year,
        'Primary Vehicle Make': car.make,
        'Primary Vehicle Model': car.model,
        'Primary Chassis': (car.model.split(' ')[0] || '').toUpperCase()
      };
      btn.disabled = true; show('Saving your ' + shortName(car) + '…');
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KEY), {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: SOURCE,
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
      }).then(function (r) {
        if (r.status !== 202 && !r.ok) {
          return r.text().then(function (t) { console.warn('[R44 garage pop-out] Klaviyo said:', r.status, t); throw new Error('status ' + r.status); });
        }
        setLS(DONE_KEY, '1');
        var id = (window.klaviyo && typeof window.klaviyo.identify === 'function') ? window.klaviyo.identify({ email: email }) : null;
        return withTimeout(id, 1500);
      }).then(function () {
        form.hidden = true;
        show('Saved! Your ' + shortName(car) + ' is in your garage.', 'success');
        var add = wrap.querySelector('.easysearch-btn-search');
        wrap.classList.remove('r44pg-gated');
        if (add) { bypass = true; add.click(); bypass = false; }
      }).catch(function () {
        btn.disabled = false;
        show('Sorry, something went wrong. Please try again.', 'error');
      });
    });
    return g;
  }

  function openGate(wrap, car) {
    var g = gateFor(wrap);
    g.querySelector('[data-r44pg-title]').innerHTML = 'Enter your email to save your <span>' + esc(shortName(car)) + '</span> to your profile';
    var form = g.querySelector('form');
    form.hidden = false;
    form.querySelector('button').disabled = false;
    g.querySelector('[data-r44pg-msg]').hidden = true;
    g.hidden = false;
    wrap.classList.add('r44pg-gated');
    setTimeout(function () { try { form.querySelector('input').focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function closeGate(wrap) {
    var g = wrap && wrap.querySelector('.r44pg');
    if (g) g.hidden = true;
    if (wrap) wrap.classList.remove('r44pg-gated');
  }

  // Runs before EasySearch's own click handlers
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wrap = wrapperOf(t);
    if (!wrap || !wrap.closest('.easysearch-garage-widget')) return;
    if (t.closest('.easysearch-btn-search')) {
      if (bypass || known()) return;
      var car = selectedCar(wrap);
      if (!car) return;                                   // let EasySearch prompt for the missing fields
      e.preventDefault();
      e.stopImmediatePropagation();
      openGate(wrap, car);
    } else if (/cancel/i.test((t.closest('a, button') || {}).textContent || '')) {
      closeGate(wrap);
    }
  }, true);

  // Pop-out side tab always reads GARAGE (EasySearch swaps in the selected car's name, which gets cut off)
  function keepTabLabel() {
    var t = document.querySelector('.easysearch-garage-widget .easysearch-garage-collapsed-title');
    if (!t) return;
    if (t.textContent !== 'Garage') t.textContent = 'Garage';
    if (!t.__r44) {
      t.__r44 = true;
      new MutationObserver(function () { if (t.textContent !== 'Garage') t.textContent = 'Garage'; })
        .observe(t, { childList: true, characterData: true, subtree: true });
    }
  }
  keepTabLabel();
  setInterval(keepTabLabel, 1000);

  // ---------- Phones: pop-out as a bottom sheet ----------
  var phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  var backdrop = null, sheetOpen = false, lockY = 0;
  function widget() { return document.querySelector('.easysearch-garage-widget'); }
  function closeSheet() { var b = widget() && widget().querySelector('.easysearch-garage-btn-close'); if (b) b.click(); }
  function fitKeyboard() {
    var w = widget(), vv = window.visualViewport;
    if (!w) return;
    if (!sheetOpen || !vv || !phone.matches) { w.style.removeProperty('--r44-kb'); w.style.removeProperty('--r44-vvh'); return; }
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    w.style.setProperty('--r44-kb', kb + 'px');
    w.style.setProperty('--r44-vvh', Math.round(vv.height) + 'px');
  }
  function setSheet(open) {
    if (open === sheetOpen) return;
    sheetOpen = open;
    var root = document.documentElement;
    if (open) {
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'r44gw-backdrop';
        backdrop.addEventListener('click', closeSheet);
        document.body.appendChild(backdrop);
      }
      lockY = window.scrollY;
      root.classList.add('r44gw-open');
    } else {
      root.classList.remove('r44gw-open');
      if (lockY && Math.abs(window.scrollY - lockY) > 2) window.scrollTo(0, lockY);
    }
    fitKeyboard();
  }
  function syncSheet() {
    var w = widget();
    setSheet(!!(w && phone.matches && w.classList.contains('easysearch-garage-opened')));
  }
  function wireSheet() {
    var w = widget();
    if (!w || w.__r44sheet) return;
    w.__r44sheet = true;
    var open = w.querySelector('.easysearch-garage-btn-open'), close = w.querySelector('.easysearch-garage-btn-close');
    if (open) open.setAttribute('aria-label', 'Open My Garage');
    if (close) close.setAttribute('aria-label', 'Close My Garage');
    new MutationObserver(syncSheet).observe(w, { attributes: true, attributeFilter: ['class'] });
    syncSheet();
  }
  wireSheet();
  setInterval(wireSheet, 1000);
  if (phone.addEventListener) phone.addEventListener('change', syncSheet);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitKeyboard);
    window.visualViewport.addEventListener('scroll', fitKeyboard);
  }
  document.addEventListener('keydown', function (e) { if (sheetOpen && e.key === 'Escape') closeSheet(); });

  // A different car picked after the email box opened: update its heading
  document.addEventListener('change', function (e) {
    var wrap = wrapperOf(e.target);
    if (!wrap || !wrap.classList.contains('r44pg-gated')) return;
    var car = selectedCar(wrap);
    if (car) openGate(wrap, car); else closeGate(wrap);
  }, true);
})();
